import SubPageMenu from "../../../../common/SubPageMenu";
import { pricingSubPages } from "./AvailabilityAndPricingPage";

const PricingMenu = (props) => {
  return <SubPageMenu 
    subPages={pricingSubPages} 
    menuId="pricingMenu"
    ariaLabel="pricing tabs example"
    {...props} 
  />
}

export default PricingMenu;